import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { setContext } from 'apollo-link-context';
import cache from './cache';
import cleanTypenameLink from './cleanTypenameFieldLink';

const uri = process.env.REACT_APP_API_URL || '/api/graphql';

const apiLink = new BatchHttpLink({
  uri
});

const authLink = setContext(async operation => {
  // try {
  //   const session = await Auth.currentSession();
  //   return { headers: { idtoken: session.getIdToken().getJwtToken() } };
  // } catch (err) {
  //   return {};
  // }
  return {};
});

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([cleanTypenameLink, authLink, apiLink])
});

export default client;
